import { handleURLForDate } from "../handleURL";
import { DateInputControl } from "../controls/DateInputControl";
import { registerDateControl } from "../state/URLStateManager";

export function addDateInputControl(map, target) {
  const dateInputControl = new DateInputControl({
    target: target,
  });
  map.addControl(dateInputControl);
  handleURLForDate(dateInputControl);
  registerDateControl(dateInputControl);
  return dateInputControl;
}
